import ReactTable from 'react-table';
import React from 'react';
import PropTypes from 'prop-types';

// Local Deps
import './RecentSolicitations.scss';
import { columns } from './gridConfig';

export default class ProcurementHistoryGrid extends React.PureComponent {
  static propTypes = {
    RecentSolicitations: PropTypes.array.isRequired,
  };

  render() {
    const { RecentSolicitations } = this.props;

    const modifiedColumns = columns.map(col => {
      if (col.accessor === 'solicitation') {
        return {
          ...col,
          Cell: row => (
            <a
              href={`https://dibbs2.bsm.dla.mil/Downloads/RFQ/${row.value.slice(-1)}/${row.value}.PDF`}
              target="_blank"
              rel="noopener noreferrer"
            >
              {row.value}
            </a>
          ),
        };
      }
      return col;
    });

    return (
      <div className="nf-drawings__grid">
        <ReactTable
          data={RecentSolicitations}
          columns={modifiedColumns}
          defaultPageSize={RecentSolicitations.length < 5 ? RecentSolicitations.length : 5}
          showPagination={RecentSolicitations.length > 5}
          noDataText={RecentSolicitations.length ? 'No Data Found' : null}
          style={{ textAlign: 'center' }}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/grids/RecentSolicitations/RecentSolicitationsGrid.jsx